// Lightweight Meta Pixel loader and helper
const PIXEL_ID = '897483689388778'
let initializationPromise = null
let initializedPixelId = null

async function sha256Hex(value) {
  const enc = new TextEncoder()
  const data = enc.encode(value.trim().toLowerCase())
  const hash = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('')
}

function loadScript() {
  if (window.fbq) return Promise.resolve()
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onload = () => resolve()
    document.head.appendChild(script)
  })
}

function ensureFbpStub() {
  if (window.fbq) return
  ;(function(f,b,e,v,n,t,s){
    if(f.fbq) return
    n=f.fbq=function(){
      n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)
    }
    if(!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t,s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
}

export async function initPixel({pixelId = PIXEL_ID, userData} = {}) {
  if (initializedPixelId === pixelId) return

  ensureFbpStub()
  if (userData?.email) {
    const em = await sha256Hex(userData.email)
    window.fbq('init', pixelId, {em})
  } else {
    window.fbq('init', pixelId)
  }
  initializedPixelId = pixelId
  trackPageView()
}

export function trackPageView(params = {}, {eventId} = {}) {
  const resolvedEventId = eventId || createEventId('PageView')

  if (window.fbq) {
    window.fbq('track', 'PageView', params, {eventID: resolvedEventId})
  }

  return resolvedEventId
}

export function createEventId(name = 'event') {
  const prefix = String(name)
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .slice(0, 40) || 'event'

  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`
  }

  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export function trackEvent(name, params = {}, {eventId} = {}) {
  const resolvedEventId = eventId || createEventId(name)

  if (window.fbq) {
    window.fbq('trackCustom', name, params, {eventID: resolvedEventId})
  }

  return resolvedEventId
}

export async function loadAndInitIfNeeded(options) {
  if (!initializationPromise) {
    initializationPromise = (async () => {
      ensureFbpStub()
      await loadScript()
      return initPixel(options)
    })().catch((error) => {
      initializationPromise = null
      throw error
    })
  }

  return initializationPromise
}

const Pixel = {
  initPixel,
  trackPageView,
  trackEvent,
  createEventId,
  loadAndInitIfNeeded,
}

export default Pixel
